import { call, put } from 'redux-saga/effects';

import api from 'api/ApiClient';
import {
  splitTreatmentsFetchSuccess,
  splitTreatmentsFetchError,
} from './actions';

export function* fetchSplitTreatments(action, apiClient = api) {
  try {
    const treatments = yield call(
      apiClient.fetchSplitTreatments,
      action.splitTreatments
    );
    yield put(splitTreatmentsFetchSuccess(treatments));
  } catch (e) {
    yield put(splitTreatmentsFetchError(e.message));
  }
}
